import React, { useState, useRef, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import html2canvas from "html2canvas";
import moment from "moment";
import axios from "axios";

// components
import {
  errorSwal,
  successDeleteSwal,
  successSwal,
} from "../../../helper/sweetalert";
import BillOfferPrice80 from "../../../components/bill/BillOfferPrice80";
import ConfirmDelete from "../../../components/ConfirmDelete";
import {
  APP_COLOR,
  LINEAR_GRADIENT_BG,
  S3_URL,
  USER_KEY,
} from "../../../const";
import CustomButton from "../../../components/CustomButton";
import { calculateTotalPaid, numberFormat } from "../../../helper";
import { base64ToBlob } from "../../../helper";

// apollo-client
import {
  DELETE_OFFERPRICE_GROUP,
  UPDATE_OFFERPRICE_ISSALE,
  UPDATE_OFFERPRICE_GROUP,
  SALE_OFFER_PRICE,
} from "../../../apollo/offerpricegroup/mutation";
import { CREATE_MANY_ORDER_WITH_ORDER_GROUP } from "../../../apollo/order/mutation";
import { GET_EXCHANGE_RATE } from "../../../apollo/product/query";
import { GET_PRINTERS } from "../../../apollo/printer/Query";
import { useLazyQuery, useMutation } from "@apollo/client";
import Swal from "sweetalert2";

// bootrap
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Spinner, Table, Form, Modal, Row, Col } from "react-bootstrap";

// icons
import { faPlus, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import {
  MdDelete,
  MdOutlineArrowBack,
  MdOutlineBorderColor,
} from "react-icons/md";
import PrintIcon from "@mui/icons-material/Print";
import { MdPrintDisabled } from "react-icons/md";
import ReactToPrint from "react-to-print";
import * as XLSX from "xlsx";
import BreadCrumbComponent from "../../../components/BreadCrumbComponent";
import { Divider } from "@mui/material";
import ComfirmModal from "../../../components/ComfirmModal";
import { GET_EXCHANGRATE } from "../../../apollo/exchangeRate/Query";
import BillOfferPriceV2 from "../../../components/bill/BillOfferPriceV2";
import BillInvioce from "../../../components/bill/BillInvoice";
import { useSelector } from "react-redux";
import BillOfferPriceV3 from "../../../components/bill/BillOfferPriceV3";
import { GET_SHOP } from "../../../apollo/shop/Query";
import _ from "lodash";
import ReceiptBill from "../../../components/bill/ReceiptBill";

export default function OfferHistoryDetail() {
  const shop = JSON.parse(localStorage.getItem("SHOP_DATA"));
  const history = useHistory();
  let componentRef = useRef();
  const location = useLocation();
  const hideMultiCurrency = shop?.id === "698acf79cd9287001309d125";
  const canToggleInvoiceMode = shop?.id === "698acf79cd9287001309d125";

  const [showDelete, setShowDelete] = useState(false);
  const [Delete, setDelete] = useState("");
  const bill80HiddenRef = useRef(null);
  const bill80SaleModalRef = useRef(null);
  const bill80PreviewModalRef = useRef(null);
  const shopIdPrinter = JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop?.id;
  const [ishowChange, setIsShowChange] = useState(false);
  const [totalbath, setTotalBaht] = useState();
  const [totalkip, setTotalKip] = useState();
  const [totalusd, setTotalUsd] = useState();
  const [offerPriceGroupData, setOfferPriceGroupData] = useState({});
  const [showModalBill, setShowModalBill] = useState(false);
  const [showModalBill80, setShowModalBill80] = useState(false);
  const [showModalReceipt, setShowModalReceipt] = useState(false);
  const [printer, setPrinter] = useState();
  const [isEdit, setIsEdit] = useState(false);
  const [editIndex, setEditIndex] = useState();
  const [editData, setEditData] = useState({});
  const [isSale, setIsSale] = useState();
  const [exchangeRate, setExchangeRate] = useState({
    bath: 0, usd: 0
  });
  const [isBillOfferPrice, setIsBillOfferPrice] = useState("BILL_OFFPRICE_V1");
  const receiptPreviewModalRef = useRef(null);

  const [isBillInvoice, setIsBillInvoice] = useState(false);
  // use client apollo use lazy
  const [getPrinterDatas, { data: printerDatas, loading: printerLoading }] =
    useLazyQuery(GET_PRINTERS, {
      fetchPolicy: "cache-and-network",
    });
  const [createManyOrderWithOrderGroup, { loading: createOrderLoading }] =
    useMutation(CREATE_MANY_ORDER_WITH_ORDER_GROUP);
  const [updateIsSale, { loading: IsSaleLoading }] = useMutation(
    UPDATE_OFFERPRICE_ISSALE
  );
  const [deleteofferpricegroup, { loading: deleteloading }] = useMutation(
    DELETE_OFFERPRICE_GROUP
  );
  const [updateOfferPriceGroup, { loading: offerpriceGrouploading }] =
    useMutation(UPDATE_OFFERPRICE_GROUP);
  const [saleOfferPrice, { loading: saleOfferPriceLoading }] =
    useMutation(SALE_OFFER_PRICE);
  const [LoadExchangeRate, { data: exchangeRateData, loading: laodingExchangrate }] = useLazyQuery(GET_EXCHANGRATE, { fetchPolicy: "network-only" });
  const [loadShop, { data: shopData, loading: loadingShop }] = useLazyQuery(GET_SHOP, { fetchPolicy: "network-only" });


  // useEffect Hooks
  useEffect(() => {
    if (shopData) {
      setIsSale(location.state.state.isSale); // เปลี่ยนเป็น `location`

      // get shop setting data from localStorage
      const shopSettingData = JSON.parse(localStorage.getItem("SHOP_SETTING_DATA"));
      if (!_.isEmpty(shopSettingData)) {
        setIsBillOfferPrice(shopSettingData?.isBillOfferPrice);
      } else {
        setIsBillOfferPrice(shopData?.shop?.isBillOfferPrice);
      }
    }

  }, [shopData]);

  useEffect(() => {
    const userData = localStorage.getItem(USER_KEY);
    if (userData) {
      const shopId = JSON.parse(userData)?.data?.shop?.id;
      if (shopId) {
        handleFecthShopData(shopId)
      }
    }
  }, []);

  useEffect(() => {
    setTotalKip(location?.state?.state.totalPrice);
    setTotalBaht(location?.state?.state.sumPriceBaht);
    setTotalUsd(location?.state?.state.sumPriceUsd);
    setOfferPriceGroupData(location?.state?.state);
    // _fetchexchangeRateData();
    _fetchPrinter();
  }, []);

  useEffect(() => {
    if (printerDatas) setPrinter(printerDatas?.printers?.data);
  }, [printerDatas]);



  useEffect(() => {
    if (exchangeRateData) {
      setExchangeRate({
        baht: exchangeRateData?.exchangeRate?.baht,
        usd: exchangeRateData?.exchangeRate?.usd
      })
      setTotalBaht(exchangeRateData?.exchangeRate?.baht);
      setTotalUsd(exchangeRateData?.exchangeRate?.usd);
    }
  }, [exchangeRateData]);


  useEffect(() => {
    _fetchExchangeRate();
  }, []);



  // get shop data
  const handleFecthShopData = async (shopId) => {
    try {
      await loadShop({
        variables: {
          where: {
            id: shopId,
          },
        },
      });

    } catch (error) {
      console.log(error)
    }
  }



  const _fetchExchangeRate = async () => {
    const shopId = await JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop?.id;
    await LoadExchangeRate({
      variables: {
        exchangeRateWhere2: {
          shop: shopId,
        },
      },
    });
  };

  // ============== > fuctions <==============
  const _saleOfferPriceGroup = async () => {
    try {
      if (IsSaleLoading || createOrderLoading || saleOfferPriceLoading) return;
      const _offerPrices = offerPriceGroupData?.offerprices?.map(
        (offerPrice) => {
          return {
            amount: offerPrice?.amount ?? 0,
            price: offerPrice?.price,
            totalPrice: offerPrice?.totalPrice,
            shop: offerPriceGroupData?.shop?.id,
            stock: offerPrice?.stock?.id,
            productName: offerPrice?.productName,
            currency: offerPrice?.currency ? offerPrice?.currency : "LAK",
            note: offerPrice?.note,
          };
        }
      );

      await saleOfferPrice({
        variables: {
          where: {
            id: offerPriceGroupData?.id,
          },
          data: {
            amount: offerPriceGroupData?.amount,
            totalPrice: offerPriceGroupData?.totalPrice,
            receivedMoney: 0,
            change: 0,
            sumPrice: offerPriceGroupData?.sumPrice,
            sumPriceBaht: offerPriceGroupData?.sumPriceBaht,
            sumPriceUsd: offerPriceGroupData?.sumPriceUsd,
            currency: offerPriceGroupData?.currency ?? "LAK",
            shop: offerPriceGroupData?.shop?.id,
            customerName: offerPriceGroupData?.customerName,
            customerLastName: offerPriceGroupData?.customerLastName,
            staff: offerPriceGroupData?.staff,
            staffLastname: offerPriceGroupData?.staffLastname,
            phone: offerPriceGroupData?.phone,
            village: offerPriceGroupData?.village,
            district: offerPriceGroupData?.district,
            province: offerPriceGroupData?.province,
            payment: offerPriceGroupData?.payment ?? "CASH",
            offerprices: _offerPrices,
          },
        },
      });

      successSwal("ສຳເລັດການຂາຍ");
      setIsShowChange(true);
      history.goBack();
    } catch (error) {
      errorSwal("ຂາຍສິນຄ້າບໍ່ສຳເລັດ...!", error);
    }
  };
  console.log("offerPriceGroupData", offerPriceGroupData);

  const _fetchPrinter = async () => {
    await getPrinterDatas({
      variables: {
        where: {
          shop: shopIdPrinter,
          isDeleted: false,
        },
      },
    });
  };
  // ==========> Fuction Update status when sale <==========

  const _updateIsSale = async () => {
    try {
      if (IsSaleLoading) return;
      await updateIsSale({
        variables: {
          where: {
            id: location?.state?.state.id,
          },
          data: { isSale: true },
        },
      });
    } catch (err) {
      console.log("error creating todo:", err);
    }
  };

  const handleShowDelete = (id) => {
    setDelete({ id });
    setShowDelete(true);
  };

  const _confirmeDelete = async () => {
    try {
      if (deleteloading) return;
      await deleteofferpricegroup({
        variables: {
          where: {
            id: location?.state?.state.id,
          },
        },
      });
      successDeleteSwal("ຍົກເລີກສຳເລັດ");
      history.goBack();
      setShowDelete(false);
    } catch (err) {
      errorSwal(err);
    }
  };

  const _updateofferprice = async () => {
    try {
      const _newOfferPrices = offerPriceGroupData?.offerprices?.map(
        (offerPrice) => {
          return {
            id: offerPrice?.id,
            amount: parseInt(offerPrice?.amount),
            totalPrice: offerPrice?.totalPrice,
            price: offerPrice?.price,
            note: offerPrice?.note,
          };
        }
      );
      await updateOfferPriceGroup({
        variables: {
          where: {
            id: location?.state?.state.id,
          },
          data: {
            amount: offerPriceGroupData?.amount,
            sumPrice: offerPriceGroupData?.sumPrice,
            totalPrice: offerPriceGroupData?.totalPrice,
            sumPriceBaht: offerPriceGroupData?.sumPriceBaht,
            sumPriceUsd: offerPriceGroupData?.sumPriceUsd,
            currency: offerPriceGroupData?.currency ?? "LAK",
            offerprices: _newOfferPrices,
          },
        },
      });

      setIsEdit(false);
      setEditIndex();
      setEditData({});
      successSwal("ເເກ້ໄຂຂໍ້ມູນສຳເລັດ");
    } catch (err) {
      errorSwal("ລາຍການສິນຄ້ານີ້ມີຢູ່ແລ້ວ");
      // console.log("error creating todo:", err);
    }
  };

  const onEditData = async (data, index) => {
    setIsEdit(true);
    setEditIndex(index);
    setEditData(data);
  };

  const onCancelEditData = async () => {
    setIsEdit(false);
    setEditIndex();
    setEditData({});
  };

  const _onChangeAmount = (offerPriceID, amount) => {
    let _newSumPriceBaht = 0;
    let _newTotalPrice = 0;
    let _newSumPriceUsd = 0;
    let _newSumPrice = 0;
    let _newTotalAmount = 0;

    const updatedOfferPrice = offerPriceGroupData?.offerprices?.map(
      (offerPrice) => {
        _newTotalAmount +=
          offerPrice.id === offerPriceID
            ? parseInt(amount)
            : parseInt(offerPrice?.amount) ?? 0;
        if (["BAHT", "ບາດ"].includes(offerPrice?.currency)) {
          _newSumPriceBaht +=
            offerPrice.id === offerPriceID
              ? amount * (offerPrice?.price ?? 0)
              : offerPrice?.totalPrice ?? 0;
          _newSumPrice +=
            (offerPrice.id === offerPriceID
              ? amount * (offerPrice?.price ?? 0)
              : offerPrice?.totalPrice ?? 0) *
            (exchangeRateData?.exchangeRate?.baht ?? 1);
        } else if (["USD", "ໂດລາ"].includes(offerPrice?.currency)) {
          _newSumPriceUsd +=
            offerPrice.id === offerPriceID
              ? amount * (offerPrice?.price ?? 0)
              : offerPrice?.totalPrice ?? 0;
          _newSumPrice +=
            (offerPrice.id === offerPriceID
              ? amount * (offerPrice?.price ?? 0)
              : offerPrice?.totalPrice ?? 0) *
            (exchangeRateData?.exchangeRate?.usd ?? 1);
        } else {
          _newTotalPrice +=
            offerPrice.id === offerPriceID
              ? amount * (offerPrice?.price ?? 0)
              : offerPrice?.totalPrice ?? 0;
          _newSumPrice +=
            offerPrice.id === offerPriceID
              ? amount * (offerPrice?.price ?? 0)
              : offerPrice?.totalPrice ?? 0;
        }
        if (offerPrice.id === offerPriceID) {
          return {
            ...offerPrice,
            amount,
            totalPrice: amount * (offerPrice?.price ?? 0),
          };
        }
        return offerPrice;
      }
    );

    const _newOfferPriceGroup = {
      ...offerPriceGroupData,
      offerprices: updatedOfferPrice,
      sumPrice: _newSumPrice,
      sumPriceBaht: _newSumPriceBaht,
      totalPrice: _newTotalPrice,
      sumPriceUsd: _newSumPriceUsd,
      amount: _newTotalAmount,
    };
    // console.log({ _newOfferPriceGroup })
    setOfferPriceGroupData(_newOfferPriceGroup);
  };

  const _onRemove = async (offerPriceID) => {
    // await _onChangeAmount(offerPriceID, 0)
    const _newOfferPrices = offerPriceGroupData?.offerprices.filter(
      (offerPrice) => offerPrice?.id !== offerPriceID
    );
    const _updatedOfferPriceGroup = {
      ...offerPriceGroupData,
      offerprices: _newOfferPrices,
    };
    // setOfferPriceGroupData(_updatedOfferPriceGroup);

    let _newSumPriceBaht = 0;
    let _newTotalPrice = 0;
    let _newSumPriceUsd = 0;
    let _newSumPrice = 0;
    let _newTotalAmount = 0;

    const updatedOfferPrice = _updatedOfferPriceGroup?.offerprices?.map(
      (offerPrice) => {
        _newTotalAmount -= parseInt(offerPrice?.amount) ?? 0;
        if (["BAHT", "ບາດ"].includes(offerPrice?.currency)) {
          _newSumPriceBaht +=
            offerPrice.id === offerPriceID
              ? 0 * (offerPrice?.price ?? 0)
              : offerPrice?.totalPrice ?? 0;
          _newSumPrice +=
            (offerPrice.id === offerPriceID
              ? 0 * (offerPrice?.price ?? 0)
              : offerPrice?.totalPrice ?? 0) *
            (exchangeRateData?.exchangeRate?.baht ?? 1);
        } else if (["USD", "ໂດລາ"].includes(offerPrice?.currency)) {
          _newSumPriceUsd +=
            offerPrice.id === offerPriceID
              ? 0 * (offerPrice?.price ?? 0)
              : offerPrice?.totalPrice ?? 0;
          _newSumPrice +=
            (offerPrice.id === offerPriceID
              ? 0 * (offerPrice?.price ?? 0)
              : offerPrice?.totalPrice ?? 0) *
            (exchangeRateData?.exchangeRate?.usd ?? 1);
        } else {
          _newTotalPrice +=
            offerPrice.id === offerPriceID
              ? 0 * (offerPrice?.price ?? 0)
              : offerPrice?.totalPrice ?? 0;
          _newSumPrice +=
            offerPrice.id === offerPriceID
              ? 0 * (offerPrice?.price ?? 0)
              : offerPrice?.totalPrice ?? 0;
        }
        // if (offerPrice.id === offerPriceID) {
        //     return { ...offerPrice, amount:0, totalPrice: 0 * (offerPrice?.price ?? 0) };
        // }
        return offerPrice;
      }
    );

    const _newOfferPriceGroup = {
      ...offerPriceGroupData,
      offerprices: updatedOfferPrice,
      sumPrice: _newSumPrice,
      sumPriceBaht: _newSumPriceBaht,
      totalPrice: _newTotalPrice,
      sumPriceUsd: _newSumPriceUsd,
      amount: _newTotalAmount,
    };
    // console.log({ _newOfferPriceGroup })
    setOfferPriceGroupData(_newOfferPriceGroup);
  };

  const onPrintBill = async () => {
    try {
      let urlForPrinter = "";
      const _printerCounters = printer;
      const printerBillData = printer?.find((e) => e?.status === true);
      if (!printerBillData) {
        await errorSwal("ບໍ່ພົບຂໍ້ມູນເຄື່ອງພິມ");
        return false;
      }

      const targetEl =
        bill80PreviewModalRef?.current ||
        bill80SaleModalRef?.current ||
        bill80HiddenRef?.current;

      if (!targetEl) {
        await errorSwal("ບໍ່ພົບແບບບິນ 80mm");
        return false;
      }

      const targetWidth = targetEl?.offsetWidth || 0;
      if (!targetWidth) {
        await errorSwal("ຂະໜາດບິນ 80mm ບໍ່ຖືກຕ້ອງ");
        return false;
      }

      let dataImageForPrint;
      // console.log("printerBillData?.width", printerBillData?.width)
      if (printerBillData?.width === "80mm") {
        dataImageForPrint = await html2canvas(targetEl, {
          useCORS: true,
          scrollX: 10,
          scrollY: 2,
          scale: 560 / targetWidth,
        });
      }
      if (!dataImageForPrint) {
        await errorSwal("ຮອງຮັບສະເພາະບິນ 80mm");
        return false;
      }
      if (printerBillData?.type === "ETHERNET") {
        urlForPrinter = "http://localhost:9150/ethernet/image";
      }
      if (printerBillData?.type === "BLUETOOTH") {
        urlForPrinter = "http://localhost:9150/bluetooth/image";
      }
      if (printerBillData?.type === "USB") {
        urlForPrinter = "http://localhost:9150/usb/image";
      }
      if (!urlForPrinter) {
        await errorSwal("ປະເພດເຄື່ອງພິມບໍ່ຖືກຕ້ອງ");
        return false;
      }

      const _file = await base64ToBlob(dataImageForPrint.toDataURL());
      var bodyFormData = new FormData();
      bodyFormData.append("ip", printerBillData?.ip);
      bodyFormData.append("port", "9100");
      bodyFormData.append("image", _file);
      bodyFormData.append("beep1", 1);
      bodyFormData.append("beep2", 9);

      await axios({
        method: "post",
        url: urlForPrinter,
        data: bodyFormData,
        headers: { "Content-Type": "multipart/form-data" },
      });

      await Swal.fire({
        icon: "success",
        title: "ປິນສຳເລັດ",
        showConfirmButton: false,
        timer: 1500,
      });
      return true;
    } catch (err) {
      console.log(err);
      await Swal.fire({
        icon: "error",
        title: "ປິນບໍ່ສຳເລັດ",
        showConfirmButton: false,
        timer: 1500,
      });
      return false;
    }
  };

  // export to excel
  const handleExport = () => {
    // Convert data to a worksheet
    const exportData = offerPriceGroupData?.offerprices.map((item) => ({
      ຊື່ສິນຄ້າ: item.productName,
      ຈຳນວນ: item.amount,
      ຫົວໜ່ວຍ: item.stock?.unitId?.name || item.stock?.unit || "-",
      ຂະໜາດ: item.stock?.size || "-",
      ແຖມ: `${item.amountFree || 0} ${item.stock?.unitId?.name || ""}`,
      ລາຄາ: item.price,
      ສະກຸນເງິນ: item.currency,
      ລາຄາລວມກີບ: item.totalPrice || 0,
      ລາຄາລວມບາດ: item.totalPriceBaht || 0, // Assuming you want empty cells for null values
      ລາຄາລວມໂດລາ: item.totalPriceUsd || 0, // Assuming you want empty cells for null values
      ໝາຍເຫດ: item.note,
    }));
    // console.log("data--6666-->", offerPriceGroupData?.offerprices)
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Export the workbook
    XLSX.writeFile(workbook, isBillInvoice ? "ໃບເກັບເງີນ.xlsx" : "ໃບສະເໜີ.xlsx");
  };


  return (
    <React.Fragment>
      <div className="offerpricehistory-detail-header">
        <BreadCrumbComponent
          goback={() => history.goBack()}
          txtFirst="ລາຍການ"
          txtSecond={`ບິນສະເໜີລາຄາ`}
        />
      </div>
      <div className="offerpricehistory-detail-main">
        <div
          style={{
            width: "100%",
            background: "white",
            padding: "2em",
          }}
          ref={componentRef}
        >
          {isBillInvoice === true && isBillOfferPrice === "BILL_OFFPRICE_V1" ? (
            <BillInvioce
              shopData={shop}
              localOrder={location?.state?.state}
              titleBill="ໃບເກັບເງີນ(INVOICE)"
              componentType="OFFERPRICE"
              providedData={offerPriceGroupData}
            />
          ) : isBillOfferPrice === "BILL_OFFPRICE_V3" ? (
            <BillOfferPriceV3
              shopData={shop}
              orderGroupData={offerPriceGroupData}
              titleBill={
                isBillInvoice
                  ? "ໃບເກັບເງີນ(INVOICE)"
                  : "QUOTATION ໃບສະເໜີລາຄາ"
              }
              isFromHistoryOfferPrice
            />
          ) : isBillOfferPrice === "BILL_OFFPRICE_V2" ? (
            <BillOfferPriceV2
              shopData={shop}
              localOrder={location?.state?.state}
              titleBill={
                isBillInvoice
                  ? "ໃບເກັບເງີນ(INVOICE)"
                  : "ໃບສະເໜີລາຄາ(Invoice)"
              }
              componentType="OFFERPRICE"
              providedData={offerPriceGroupData}
            />
          ) : (
            <div>
              <div>
                <div
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: "18px",
                  }}
                >
                  ຮ້ານ {shop?.name}
                </div>
                <div
                  style={{
                    textAlign: "center",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <div style={{ paddingLeft: "10px", paddingBottom: "10px" }}>
                    <img src={S3_URL + shop?.image} width="60px" alt="shop" />
                  </div>
                  &emsp;
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-start",
                    }}
                  >
                    <div>
                      {shop?.address?.village +
                        ", " +
                        shop?.address?.district +
                        ", " +
                        shop?.address?.province}
                    </div>
                    <div> ໂທ : {shop?.phone} Email:</div>
                  </div>
                </div>
              </div>

              <div
                style={{
                  fontWeight: "bold",
                  textAlign: "center",
                  fontSize: "23px",
                  padding: "1em 0",
                }}
              >
                <b> ໃບສະເໜີລາຄາ / Quotation</b>
              </div>
              <div>ຂໍຮຽນ :</div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    border: "1px solid #ddd",
                    display: "flex",
                    flexDirection: "column",
                    width: "70%",
                    padding: "5px",
                  }}
                >
                  <span>
                    ລູກຄ້າ : {location?.state?.state.customerName}{" "}
                    {location?.state?.state.customerLastName}
                  </span>
                  <span>
                    ທີ່ຢູ່ : {location?.state?.state?.village},{" "}
                    {location?.state?.state?.district},{" "}
                    {location?.state?.state?.province}{" "}
                  </span>
                  <span>Tel :&emsp;{location?.state?.state.phone}</span>
                </div>
                &emsp;
                <div
                  style={{
                    border: "1px solid #ddd",
                    display: "flex",
                    flexDirection: "column",
                    width: "30%",
                    padding: "5px",
                  }}
                >
                  <span>ເລກທີ່ບິນ : {location?.state?.state.code} </span>
                  <span>
                    ວັນທີ :{" "}
                    {moment(offerPriceGroupData?.createdAt).format(
                      "DD/MM/YYYY HH:mm:ss"
                    )}
                  </span>
                  <span>Credit :</span>
                  <span>ໝົດກຳນົດ :</span>
                </div>
              </div>

              <div style={{ marginTop: "5px" }}>
                <div style={{ height: "auto" }}>
                  <Table size="sm">
                    <thead>
                      <tr style={{ background: LINEAR_GRADIENT_BG, color: "#fff", "--bs-table-bg": "transparent", "--bs-table-color": "#fff" }}>
                        <th style={{ background: "transparent", color: "#fff" }}>ລ/ດ</th>
                        <th style={{ background: "transparent", color: "#fff" }}>ຊື່ສິນຄ້າ / Description</th>
                        <th style={{ background: "transparent", color: "#fff" }}>ຈຳນວນ</th>
                        <th style={{ background: "transparent", color: "#fff" }}>ຫົວໜ່ວຍ</th>
                        <th style={{ background: "transparent", color: "#fff" }}>ລາຄາໝວ່ຍ</th>
                        <th style={{ background: "transparent", color: "#fff" }}>ລາຄາລວມ</th>
                        <th style={{ background: "transparent", color: "#fff" }}>ສະກຸນເງີນ</th>
                        <th style={{ background: "transparent", color: "#fff" }}>ໝາຍເຫດ</th>
                        {ishowChange ? <th style={{ background: "transparent", color: "#fff" }}>ຈັດການ</th> : ""}
                      </tr>
                    </thead>
                    <tbody style={{ fontSize: "14px" }}>
                      {offerPriceGroupData?.offerprices?.map((order, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{order?.productName}</td>
                          <td>
                            {ishowChange ? (
                              <Form.Control
                                type="number"
                                name="amount"
                                onChange={(e) => {
                                  let _data = { ...editData };
                                  _data.amount = e?.target?.value;
                                  setEditData(_data);
                                  _onChangeAmount(order?.id, e?.target?.value);
                                }}
                                value={order?.amount}
                                placeholder="ຈຳນວນ..."
                              />
                            ) : (
                              <div>{order?.amount}</div>
                            )}
                          </td>
                          <td>
                            {order?.stock?.unitId?.name ?? order?.stock?.unit}
                          </td>
                          <td>
                            {order?.price ? numberFormat(order?.price) : "-"}
                          </td>
                          <td>{numberFormat(order?.totalPrice)}</td>
                          <td>
                            {order?.currency === "BAHT" ? "THB" : order?.currency}
                          </td>
                          <td>{order?.note}</td>
                          {ishowChange && (
                            <td>
                              <CustomButton
                                width="50px"
                                height="42px"
                                color="red"
                                background="#F1F1F1"
                                borderRadius="8px"
                                title=""
                                icon={<FontAwesomeIcon icon={faTrashAlt} />}
                                onClick={() => _onRemove(order?.id)}
                              />
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
                <Divider />
                <div
                  style={{
                    display: "flex",
                    gap: 5,
                    width: "100%",
                    marginTop: "20px",
                    border: "1px solid #ddd",
                    padding: "10px",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: "auto",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "space-between",
                      }}
                    >
                      <span>ຍອດລວມ ກີບ:</span>
                      <span>
                        {" "}
                        {numberFormat(location?.state?.state?.totalPrice ?? 0)}{" "}
                        ₭
                      </span>
                    </div>
                    {!hideMultiCurrency && (
                      <>
                        <div style={{ marginTop: 8 }}>
                          <div
                            style={{
                              display: "flex",
                              width: "100%",
                              justifyContent: "flex-end",
                              marginRight: "10px",
                            }}
                          >
                            <span>
                              {numberFormat(location?.state?.state?.sumPriceBaht ?? 0)}{" "}
                              ฿
                            </span>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              width: "100%",
                              justifyContent: "flex-end",
                            }}
                          >
                            <span>
                              {numberFormat(location?.state?.state?.sumPriceUsd ?? 0)}{" "}
                              $
                            </span>
                          </div>
                        </div>

                        <Divider />

                        <div
                          style={{
                            display: "flex",
                            width: "100%",
                            justifyContent: "space-between",
                          }}
                        >
                          <span>
                            <b>ເງິນທີ່ຕ້ອງຈ່າຍ:</b>
                          </span>
                          <span>
                            <b>{numberFormat(location?.state?.state?.sumPrice ?? 0)} ກີບ</b>
                          </span>
                        </div>
                      </>
                    )}
                  </div>
                </div>
                <div style={{ display: "flex", marginTop: "20px", width: "100%" }}>
                  <div
                    style={{
                      width: "100%",
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      height: "100px",
                      fontSize: "12px",
                    }}
                  >
                    <div style={{ textAlign: "center" }}>
                      (...)
                      <br /> ຜູ້ສະເໜີລາຄາ
                    </div>
                  </div>
                  &ensp;
                  <div
                    style={{
                      width: "100%",
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      height: "100px",
                      fontSize: "12px",
                    }}
                  >
                    <div style={{ textAlign: "center" }}>
                      (...)
                      <br />
                      Sale Manager
                    </div>
                  </div>
                  &ensp;
                  <div
                    style={{
                      width: "100%",
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      height: "100px",
                      fontSize: "12px",
                    }}
                  >
                    <div style={{ textAlign: "center" }}>
                      ລູກຄ້າເຊັນຮັບເຄື່ອງ
                      <br />
                      ລົງວັນທີເເລະປະທັບຕາ (ຖ້າມີ)
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {isSale ? (
          <Row className="p-2">
            <Col>
              <CustomButton
                icon={<MdOutlineArrowBack />}
                border={`1px solid red`}
                background="red"
                color="#ffffff"
                width={"100%"}
                height={42}
                borderRadius={4}
                title={"ກັບຄືນ"}
                tooltip="ກັບຄືນໄປໜ້າກ່ອນ"
                onClick={() => history.goBack()}
              />
            </Col>
            <Col>
              <ReactToPrint
                trigger={() => (
                  <CustomButton
                    title=" ພິມບິນ"
                    icon={<PrintIcon />}
                    width={"100%"}
                    height={42}
                    borderRadius={4}
                    background="green"
                    tooltip="ພິມເອກະສານ"
                  />
                )}
                content={() => componentRef.current}
              />
            </Col>
            <Col>
              <CustomButton
                icon={<MdDelete />}
                border={`1px solid red`}
                background="red"
                color="#ffffff"
                width={"100%"}
                height={42}
                borderRadius={4}
                title={"ລົບອອກ"}
                tooltip="ລົບລາຍການຂາຍນີ້"
                onClick={(e) => setShowDelete(true)}
              />
            </Col>
            <Col>
              <CustomButton
                title=" ໃບຮັບເງິນ"
                icon={<PrintIcon />}
                width={"100%"}
                height={42}
                borderRadius={4}
                background="#0B5ED7"
                tooltip="ກົດເພື່ອເບິ່ງໃບຮັບເງິນ"
                onClick={() => setShowModalReceipt(true)}
              />
            </Col>
            <Col>
              <CustomButton
                title=" ພິມບິນ 80"
                icon={<PrintIcon />}
                width={"100%"}
                height={42}
                borderRadius={4}
                background="#1F3A60"
                tooltip="ພິມເອກະສານຂະໜາດ 80mm"
                onClick={() => setShowModalBill80(true)}
              />
            </Col>
            <Col>
              <CustomButton
                background={LINEAR_GRADIENT_BG}
                width={"100%"}
                height={42}
                borderRadius={4}
                title={"Export As Excel"}
                tooltip="ດາວໂຫລດເປັນໄຟລ໌ Excel"
                onClick={handleExport}
              />
            </Col>
          </Row>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              paddingBottom: "50px",
              width: "820px",
            }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                marginTop: "25px",
              }}
            >
              <div
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  color: "#1F3A60",
                  marginBottom: "8px",
                  textAlign: "left",
                }}
              >
                ຈັດການຮູບແບບເອກະສານ: (ໃບສະເໜີລາຄາ / ໃບເກັບເງີນ)
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 10,
                  width: "100%",
                }}
              >
                <CustomButton
                  title=" ໃບຮັບເງິນ"
                  icon={<PrintIcon />}
                  width={"100%"}
                  height={42}
                  borderRadius={4}
                  background="#0B5ED7"
                  tooltip="ກົດເພື່ອເບິ່ງໃບຮັບເງິນ"
                  onClick={() => setShowModalReceipt(true)}
                />
                <CustomButton
                  icon={<MdDelete />}
                  border={`1px solid red`}
                  background="red"
                  color="#ffffff"
                  width="100%"
                  height={42}
                  borderRadius={4}
                  title={"ລົບອອກ"}
                  tooltip="ລົບລາຍການສະເໜີລາຄານີ້"
                  onClick={(e) => setShowDelete(true)}
                />
                {canToggleInvoiceMode ? (
                  <CustomButton
                    border={`1px solid #1F3A60`}
                    background="#1F3A60"
                    color="#ffffff"
                    width="100%"
                    height={42}
                    borderRadius={4}
                    title={
                      !isBillInvoice ? "ສະຫຼັບເປັນໃບເກັບເງີນ" : "ສະຫຼັບເປັນໃບສະເໜີລາຄາ"
                    }
                    tooltip={
                      !isBillInvoice
                        ? "ກົດເພື່ອສະຫຼັບເປັນໃບເກັບເງີນ"
                        : "ກົດເພື່ອສະຫຼັບເປັນໃບສະເໜີລາຄາ"
                    }
                    onClick={() => setIsBillInvoice(!isBillInvoice)}
                  />
                ) : null}
                {!ishowChange ? (
                  <CustomButton
                    icon={
                      saleOfferPriceLoading ? (
                        <Spinner size="sm" animation="border" />
                      ) : (
                        <AttachMoneyIcon />
                      )
                    }
                    background={LINEAR_GRADIENT_BG}
                    width={"100%"}
                    height={42}
                    borderRadius={4}
                    title={"ຂາຍ"}
                    tooltip="ຢືນຢັນການຂາຍ"
                    onClick={() => setShowModalBill(true)}
                  />
                ) : (
                  ""
                )}
                <ReactToPrint
                  trigger={() => (
                    <CustomButton
                      title=" ພິມບິນ"
                      icon={<PrintIcon />}
                      width={"100%"}
                      height={42}
                      borderRadius={4}
                      background="green"
                      tooltip="ພິມເອກະສານ"
                    />
                  )}
                  content={() => componentRef.current}
                />
                <CustomButton
                  title=" ພິມບິນ 80"
                  icon={<PrintIcon />}
                  width={"100%"}
                  height={42}
                  borderRadius={4}
                  background="#1F3A60"
                  tooltip="ພິມເອກະສານຂະໜາດ 80mm"
                  onClick={() => setShowModalBill80(true)}
                />
                <CustomButton
                  background={LINEAR_GRADIENT_BG}
                  width={"100%"}
                  height={42}
                  borderRadius={4}
                  title={"Export As Excel"}
                  tooltip="ດາວໂຫລດເປັນໄຟລ໌ Excel"
                  onClick={handleExport}
                />
                <CustomButton
                  width="100%"
                  height="42px"
                  textalign="center"
                  title="ເພີ່ມສິນຄ້າ"
                  color="#fff"
                  background={LINEAR_GRADIENT_BG}
                  tooltip="ເພີ່ມສິນຄ້າເຂົ້າໃນລາຍການນີ້"
                  icon={
                    <FontAwesomeIcon
                      icon={faPlus}
                      style={{
                        marginRight: 10,
                        color: "#fff",
                        fontSize: "18px",
                      }}
                    />
                  }
                  onClick={() =>
                    history.push("/offerprice/limit/50/page/1", {
                      state: offerPriceGroupData,
                      isEdited: true,
                      isFromSale: false,
                    })
                  }
                />
              </div>
            </div>
          </div>
        )}
      </div>

      <ComfirmModal
        showConfirmModal={showDelete}
        handleCancel={() => setShowDelete(false)}
        handleConfirm={_confirmeDelete}
        title="ແຈ້ງເຕືອນ"
        text={"ທ່ານຕອ້ງການຈະລົບຂໍ້ມູນ ນີ້ເເທ້ບໍ່"}
      />

      <div
        style={{ width: "80mm", position: "absolute", top: "-9999px" }}
        ref={bill80HiddenRef}
      >
        <BillOfferPrice80
          offerPriceGroupData={offerPriceGroupData}
          Location={location}
        />
      </div>

      <Modal
        show={showModalReceipt}
        onHide={() => setShowModalReceipt(false)}
        size="lg"
      >
        <Modal.Body style={{ display: "flex", justifyContent: "center" }}>
          <div style={{ width: "794px" }} ref={receiptPreviewModalRef}>
            <ReceiptBill
              shopData={shop}
              orderGroupData={offerPriceGroupData}
              title="ໃບຮັບເງິນ (Receipt)"
            />
          </div>
        </Modal.Body>
        <Modal.Footer style={{ display: "flex", justifyContent: "center" }}>
          <CustomButton
            width={140}
            height={42}
            borderRadius={4}
            background="transparent"
            color="#3C169B"
            border="1px solid #3C169B "
            fontweight={400}
            title={"ຍົກເລີກ"}
            onClick={() => setShowModalReceipt(false)}
          />
          &ensp;
          <ReactToPrint
            trigger={() => (
              <CustomButton
                width={140}
                height={42}
                background="#0B5ED7"
                borderRadius={4}
                title={" ພິມບິນ"}
                icon={<PrintIcon />}
              />
            )}
            content={() => receiptPreviewModalRef.current}
            onAfterPrint={() => setShowModalReceipt(false)}
          />
        </Modal.Footer>
      </Modal>

      <Modal show={showModalBill80} onHide={() => setShowModalBill80(false)}>
        <Modal.Body style={{ display: "flex", justifyContent: "center" }}>
          <div style={{ width: "80mm" }} ref={bill80PreviewModalRef}>
            <BillOfferPrice80
              offerPriceGroupData={offerPriceGroupData}
              Location={location}
            />
          </div>
        </Modal.Body>
        <Modal.Footer style={{ display: "flex", justifyContent: "center" }}>
          <CustomButton
            width={140}
            height={42}
            borderRadius={4}
            background="transparent"
            color="#3C169B"
            border="1px solid #3C169B "
            fontweight={400}
            title={"ຍົກເລີກ"}
            onClick={() => setShowModalBill80(false)}
          />
          &ensp;
          <CustomButton
            width={140}
            height={42}
            background="#1F3A60"
            borderRadius={4}
            title={" ພິມບິນ"}
            icon={<PrintIcon />}
            onClick={async () => {
              const ok = await onPrintBill();
              if (ok) setShowModalBill80(false);
            }}
          />
        </Modal.Footer>
      </Modal>

      <Modal show={showModalBill} onHide={() => setShowModalBill(false)}>
        <Modal.Body style={{ display: "flex", justifyContent: "center" }}>
          <div style={{ width: "80mm" }} ref={bill80SaleModalRef}>
            <BillOfferPrice80
              offerPriceGroupData={offerPriceGroupData}
              Location={location} // เปลี่ยนเป็น `location`
            />
          </div>
        </Modal.Body>
        <Modal.Footer style={{ display: "flex", justifyContent: "center" }}>
          <CustomButton
            width={140}
            height={42}
            borderRadius={4}
            background="transparent"
            color="#3C169B"
            border="1px solid #3C169B "
            fontweight={400}
            title={"ຍົກເລີກ"}
            onClick={() => setShowModalBill(false)}
          />
          &ensp;
          <CustomButton
            width={140}
            height={42}
            background="#1F3A60"
            borderRadius={4}
            title={" ຮັບບິນ"}
            icon={<PrintIcon />}
            onClick={async () => {
              await onPrintBill();
              _saleOfferPriceGroup();
            }}
          />
          &ensp;
          <CustomButton
            width={140}
            height={42}
            background="#1F3A60"
            borderRadius={4}
            icon={<MdPrintDisabled size={25} />}
            title={
              saleOfferPriceLoading ? (
                <Spinner size="sm" animation="border" />
              ) : (
                " ບໍ່ຮັບບິນ"
              )
            }
            onClick={() => _saleOfferPriceGroup()}
          />
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}
